import { render, staticRenderFns } from "./AbilityRecord.vue?vue&type=template&id=f951be94&scoped=true"
import script from "./AbilityRecord.vue?vue&type=script&lang=js"
export * from "./AbilityRecord.vue?vue&type=script&lang=js"
import style0 from "./AbilityRecord.vue?vue&type=style&index=0&id=f951be94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f951be94",
  null
  
)

export default component.exports